function parseDateAsUtc(value) {
  if (!value || typeof value !== "string") {
    return null
  }

  const [year, month, day] = value.split("-").map(Number)
  if (!year || !month || !day) {
    return null
  }

  const parsed = new Date(Date.UTC(year, month - 1, day))
  if (Number.isNaN(parsed.getTime())) {
    return null
  }

  return parsed
}

export function validateAuthorizeAttendancePeriod(startDate, endDate, maxDays = 90) {
  if (!startDate || !endDate) {
    return {
      valid: false,
      errorKey: "periodRequired",
    }
  }

  const start = parseDateAsUtc(startDate)
  const end = parseDateAsUtc(endDate)

  if (!start || !end) {
    return {
      valid: false,
      errorKey: "periodInvalid",
    }
  }

  if (end < start) {
    return {
      valid: false,
      errorKey: "periodOrderInvalid",
    }
  }

  const diffInDays = Math.floor((end.getTime() - start.getTime()) / 86400000) + 1
  if (diffInDays > maxDays) {
    return {
      valid: false,
      errorKey: "periodLimitExceeded",
      days: diffInDays,
      maxDays,
    }
  }

  return {
    valid: true,
    days: diffInDays,
    maxDays,
  }
}
